<template>
  <div class="page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">应用中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/pc/index' }">PC网站</el-breadcrumb-item>
      <el-breadcrumb-item>滚动图</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <div class="menu-area">
        <el-button type="primary" @click="toAdd">添加滚动图</el-button>
      </div>
      <el-table :data="dataList" border style="width: 100%" max-height="500">
        <el-table-column prop="id" label="#" width="80"></el-table-column>
        <el-table-column prop="type" label="归属栏目" width="200">
          <template slot-scope="scope">
            <el-tag effect="plain" v-if="scope.row.type === 1">首页</el-tag>
            <el-tag type="success" effect="plain" v-if="scope.row.type === 2">产品与服务列表</el-tag>
            <el-tag type="info" effect="plain" v-if="scope.row.type === 3">客户案例</el-tag>
            <el-tag type="danger" effect="plain" v-if="scope.row.type === 4">新闻资讯</el-tag>
            <el-tag type="warning" effect="plain" v-if="scope.row.type === 5">下载中心</el-tag>
            <el-tag type="success" effect="plain" v-if="scope.row.type === 6">产品价格</el-tag>
            <el-tag type="info" effect="plain" v-if="scope.row.type === 7">关于我们</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="图片">
          <template slot-scope="scope">
            <el-image class="banner-img" :src="scope.row.url" :preview-src-list="[scope.row.url]" lazy></el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="330">
          <template slot-scope="scope">
            <el-button size="small" type="success" @click="editItem(scope.row.id)">编辑</el-button>
            <el-button type="danger" size="small" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      dataList: []
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get('/pc-banner-list')
      if (res.status === 200) {
        this.dataList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    editItem (id) {
      this.$router.push('/admin/apps/pc/banner/edit/' + id)
    },
    async delItem (id) {
      const { data: res } = await this.$http.delete('/pc-banner/', { params: { id: id } })
      if (res.status === 200) {
        this.$message.success(res.msg)
        await this.getData()
      } else {
        this.$message.error(res.msg)
      }
    },
    toAdd () {
      this.$router.push('/admin/apps/pc/banner/add')
    }
  }
}
</script>

<style scoped>
.menu-area{
  padding: 0 0 20px 0;
  text-align: right;
}
.banner-img{
  max-width: 100px;
  max-height: 50px;
}
</style>
